<template>
  <div id="app-curriculum-right">
    <!-- 顶栏 -->
    <div id="app-curriculum-right-title">
      <h1 id="app-curriculum-right-t1">{{ curriculumInfo.curriculumData.name }}</h1>
      <div id="app-curriculum-right-title-other">
        <span id="app-curriculum-right-p"></span>
        <span id="app-curriculum-right-p2">{{ curriculumInfo.curriculumData.collectionTimes }}人正在学习</span>
        <em class="el-icon-share" id="app-curriculum-right-share" v-on:click="onCopy()">分享</em>
      </div>
    </div>
    <!-- 课程树 -->
    <div id="app-curriculum-right-tree">
      <div id="app-curriculum-right-tree-body">
        <el-timeline>
          <el-timeline-item v-for="item in curriculumInfo.chapterData" :key="item.id" :timestamp="item.chapterInfo.name"
                            placement="top">
            <div class="app-curriculum-item">
              <ul>
                <li v-for="items in item.classInfo" :key="items.id" style="float:left;cursor:pointer"
                    v-on:click="openClass(items.id)">
                  <el-card class="app-curriculum-item-card">
                    <img alt="pic" :src="items.coverPhoto"/>
                    <p class="app-curriculum-item-card-title">{{ items.name }}</p>
                    <div class="app-curriculum-item-card-other">
                      <i class="el-icon-star-off"></i>
                      <span> {{ items.collectionTimes }} </span>
                      <i class="el-icon-view"></i>
                      <span> {{ items.viewTimes }} </span>
                      <p class="app-curriculum-item-card-time">
                        {{ new Date(items.createTime).toLocaleDateString().replace(/\//g, '-') }}</p>
                    </div>
                  </el-card>
                </li>
              </ul>
              <div style="clear:both;"></div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>

import {Message} from "element-ui";

export default {
  name: "InfoRight",
  props: {
    curriculumInfo: {
      curriculumData: {
        name: '',
        coverPhoto: '',
        remark: '',
      },
      chapterData: [
        {
          chapterInfo: {
            name: ''
          },
          classInfo: [
            {
              id: '',
              name: '',
              coverPhoto: '',
              createTime: '',
              viewTimes: 0,
              collectionTimes: 0
            }
          ]
        }
      ]
    }
  },
  data() {
    return {
      ccTotal: 0
    }
  },
  mounted() {
    for (let point = 0; point < this.curriculumInfo.chapterData.length; point++) {
      for (let points = 0; points < this.curriculumInfo.chapterData[point].classInfo.length; points++) {
        this.ccTotal++;
      }
    }
    document.getElementById("app-curriculum-right-p").innerText = "共" + this.ccTotal + "节课程"
  },
  methods: {
    onCopy() {
      this.$copyText(window.location.href).then(function () {
        Message({
          showClose: true,
          message: '成功复制连接到剪切板',
          type: 'success'
        });
      })
    },
    openClass(id) {
      window.open(this.$router.resolve("/article/" + id).href)
    }
  }
}
</script>

<style scoped>

#app-curriculum-right {
  position: relative;
  left: 325px;
  width: 800px;
  height: 850px;
  top: 15px;
}

#app-curriculum-right-title {
  position: relative;
  width: 800px;
  height: 120px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.4);
  text-align: left;
}

#app-curriculum-right-t1 {
  position: absolute;
  font-size: 24px;
  left: 0;
  top: 25px;
}

#app-curriculum-right-title-other {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  height: 25px;
  font-size: 12px;
  color: rgba(20, 20, 20, 0.4);
}

#app-curriculum-right-p2 {
  margin-left: 25px;
}

#app-curriculum-right-share {
  position: absolute;
  right: 0;
  color: #000000;
  font-size: 20px;
  cursor: pointer;
}

#app-curriculum-right-tree {
  position: relative;
  width: 800px;
  height: 600px;
  padding: 25px 0 25px 0;
  text-align: left;
}

#app-curriculum-right-tree-body {
  position: absolute;
  overflow-y: scroll;
  top: 25px;
  right: 0;
  left: 0;
  bottom: 0;
  padding-right: 25px;
}

.app-curriculum-item {
  position: relative;
  width: 100%;
  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.10);*/
}

.app-curriculum-item-card {
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 230px;
  height: 250px;
  cursor: pointer;
  /*border: 0;*/
}

.app-curriculum-item-card img {
  width: 230px;
  height: 160px;
}

.app-curriculum-item-card:hover {
  transition: all 200ms ease-out;
  transform: scale(1.05);
  /*background: #FF8A00 !important;*/
}


.app-curriculum-item-card-title {
  margin: 5px 10px 0 10px;
  height: 35px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.app-curriculum-item-card-other {
  position: relative;
  left: 0;
  height: 35px;
  width: 220px;
  text-align: left;
}

.app-curriculum-item-card-time {
  position: absolute;
  bottom: -6px;
  right: 2px;
  font-size: 10px;
}

.app-curriculum-item-card-other i {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 5px;
}

.app-curriculum-item-card-other span {
  position: relative;
  left: 3px;
}

</style>